import { z } from 'zod';

/**
 * The dashboard's URL state (HS-1634): which of the caller's current jobs is shown when there are
 * several (one per institution, HS-980 U22). Optional and forgiving — a job that closed meanwhile,
 * or a hand-edited value, falls back to the default (the oldest assigned) rather than throwing.
 */
export const installerDashboardSearchSchema = z.object({
  job: z.string().min(1).optional().catch(undefined),
});

export type InstallerDashboardSearch = z.infer<typeof installerDashboardSearchSchema>;
